import React from 'react'
import {Flex, Text, Image, Box, useMultiStyleConfig, Button} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {useHistory} from 'react-router-dom'

export default function ErrorAndMaintenancePage() {
    const styles = useMultiStyleConfig('ErrorAndMaintenancePage', {})
    const {errorPage} = styles
    const history = useHistory()

    return (
        <Box {...errorPage?.pageContainer} data-status-code="404">
            <Flex {...errorPage?.messageContainer} data-testid="message-container">
                <Flex {...errorPage?.messageTextContainer}>
                    <Text {...errorPage?.messageTitle}>
                        <FormattedMessage id="error_page_message.title" defaultMessage="404" />
                    </Text>
                    <Text {...errorPage?.messageText}>
                        <FormattedMessage
                            id="error_page_message.message"
                            defaultMessage="Oops, something went wrong. The page you are looking for cannot be found."
                        />
                    </Text>
                    <Button
                        {...errorPage?.goBackButton}
                        variant="inverse-secondary"
                        onClick={() => history.goBack()}
                        data-testid="go-back-button"
                    >
                        <FormattedMessage
                            id="error_page_button.button_text"
                            defaultMessage="Go back to previous page"
                        />
                    </Button>
                </Flex>
                <Box {...errorPage?.imageContainer}>
                    <Image
                        {...errorPage?.imageElement}
                        alt="an image of a product"
                        src={getAssetUrl('static/img/404Image.png')}
                        data-testid="error-image"
                    />
                </Box>
            </Flex>
        </Box>
    )
}
